import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PlaceIcon from "@mui/icons-material/Place";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Typography, IconButton, Box, Link, SvgIcon } from "@mui/material";
import { SiThreads } from "react-icons/si";


export const StoreInfoBanner = ({ info, loading, error, theme }) => {



  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        background: `linear-gradient(145deg, ${theme.palette.bonus}, ${theme.palette.info.dark})`,
        color: theme.palette.common.white,
        textAlign: "center",
        paddingTop: 3,
        paddingBottom: 9,
        boxShadow: "0 -4px 20px rgba(0,0,0,0.15)",
      }}
    >
      {loading ? (
        <Typography>Loading store info...</Typography>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <>
          {/* Store Name */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              letterSpacing: 1,
              mb: 3,
              fontSize: { xs: "1.5rem", sm: "2rem" },
            }}
          >
            {info?.name ?? "AI GOLF"}
          </Typography>

          {/* Info Grid */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "auto 1fr" },
              justifyContent: "center",
              alignItems: "center",
              rowGap: 1.5,
              columnGap: 2,
              maxWidth: 520,
              mx: "auto",
              textAlign: { xs: "center", sm: "left" },
              color: "white",
            }}
          >
            {/* Row: Business Hours */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <AccessTimeIcon sx={{ mr: 1 }} />
              <Typography>營業時間：{info?.businessHours}</Typography>
            </Box>

            {/* Row: Address */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <PlaceIcon sx={{ mr: 1 }} />
              <Typography>地址：{info?.address}</Typography>
            </Box>

            {/* Row: Phone */}
            {info?.phone && (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <LocalPhoneIcon sx={{ mr: 1 }} />
                <Typography>
                  <Link href={`tel:${info?.phone}`} underline="hover" color="inherit">
                    電話：{info?.phone}
                  </Link>
                </Typography>
              </Box>
            )}

            {/* Row: Email */}
            {info?.email && (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <EmailOutlinedIcon sx={{ mr: 1 }} />
                <Typography>
                信箱：
                  <Link href={`mailto:${info?.email}`} color="inherit">
                    {info?.email}
                  </Link>
                </Typography>
              </Box>
            )}
          </Box>

          {/* Social Icons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap",
              mt: 2,
            }}
          >
            {info?.instagram && (
              <IconButton
                href={info.instagram}
                target="_blank"
                aria-label="Instagram"
                sx={{ color: "white", "&:hover": { transform: "scale(1.1)", transition: "0.2s" } }}
              >
                <InstagramIcon fontSize="large" />
              </IconButton>
            )}

            {info?.facebook && (
              <IconButton
                href={info.facebook}
                target="_blank"
                aria-label="Facebook"
                sx={{ color: "white", "&:hover": { transform: "scale(1.1)", transition: "0.2s" } }}
              >
                <FacebookIcon fontSize="large" />
              </IconButton>
            )}

            {info?.threads && (
          <IconButton
                href={info?.threads}
                target="_blank"
                aria-label="Threads"
                sx={{ color: "white", "&:hover": { transform: "scale(1.1)", transition: "0.2s" } }}
              >
  
                <SiThreads style={{ fontSize: 32, display: "block" }} />
              </IconButton>
            )}

            {info?.lineOfficial && (
              <IconButton
                href={info?.lineOfficial}
                target="_blank"
                aria-label="LINE"
                sx={{ "&:hover": { transform: "scale(1.1)", transition: "0.2s" } }}
              >
                <Box
                  component="img"
                  src={`${process.env.REACT_APP_API_ENDPOINT}/media/line.png`}
                  alt="LINE"
                  sx={{
                    width: 30,
                    height: 30,
                    filter: "brightness(100%)",
                    transition: "0.2s",
                    "&:hover": { filter: "brightness(120%)" },
                  }}
                />
              </IconButton>
            )}
          </Box>

          {/* Note */}
          {info?.note && (
            <Typography
              sx={{
                fontSize: "0.95rem",
                opacity: 0.9,
                maxWidth: 600,
                mx: "auto",
                mt: 2,
                lineHeight: 1.3,
                color: "white",
              }}
            >
              {info.note}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};
